import { ResponseModel, handleGetAsync, handlePostAsync, handlePutAsync, handleDeleteAsync } from "../../components/common/commonclass";
import { EndPoint } from "../../components/common/config";
import { handleNotify, TOASTER_POSITION, TOASTER_TYPE } from "../../components/common/notification/toaster_notify.component";

var responseModel = new ResponseModel();

export class CustomerService {
    // Get All 
    static async getAllCustomers(storeId = null) {
        responseModel = new ResponseModel();
        const requestURL = `${EndPoint.CUSTOMERS}`; // endpoint
        const requestModel = { storeId };
        responseModel = await handleGetAsync(requestURL, true, requestModel);
        if (responseModel) {
            return responseModel;
        } else {
            console.error('Failed to fetch customers.');
            return [];
        }
    }

    // Create 
    static async addNewCustomer(data) {
        responseModel = new ResponseModel();
        const requestURL = `${EndPoint.CUSTOMERS}`; // endpoint

        responseModel = await handlePostAsync(requestURL, true, data);

        if (responseModel) {
            handleNotify('Customer added successfully!', TOASTER_TYPE.SUCCESS, TOASTER_POSITION.TOP_RIGHT);
            return responseModel;
        } else {
            throw new Error('Failed to create new customer.');
        }
    }

    // Get by ID
    static async getCustomerById(id) {
        responseModel = new ResponseModel();
        const requestURL = `${EndPoint.CUSTOMERS}/${id}`; // endpoint

        responseModel = await handleGetAsync(requestURL, true);
        if (responseModel) {
            return responseModel;
        } else {
            throw new Error('Failed to fetch customer by ID');
        }
    }

    // Update
    static async updateCustomerById(id, data) {
        responseModel = new ResponseModel();
        const requestURL = `${EndPoint.CUSTOMERS}/${id}`; // endpoint

        responseModel = await handlePutAsync(requestURL, true, data);
        if (responseModel) {
            handleNotify('Customer updated successfully.', TOASTER_TYPE.SUCCESS, TOASTER_POSITION.TOP_RIGHT);
            return responseModel;
        } else {
            throw new Error('Failed to update customer.');
        }
    }

    // Delete by ID
    static async deleteCustomer(id) {
        responseModel = new ResponseModel();
        const requestURL = `${EndPoint.CUSTOMERS}/${id}`; // endpoint

        try {
            responseModel = await handleDeleteAsync(requestURL, true);
            if (responseModel) {
                return responseModel;
            } else {
                throw new Error('Failed to delete customer.');
            }
        } catch (error) {
            console.error('Error deleting customer:', error);
            throw error;
        }
    }

    // Delete Multiple 
    static async deleteManyCustomers(ids) {
        responseModel = new ResponseModel();
        const requestURL = `${EndPoint.CUSTOMERS}/deletemany`; // endpoint

        responseModel = await handleDeleteAsync(requestURL, true, ids);
        if (responseModel) {
            handleNotify(responseModel.message, TOASTER_TYPE.SUCCESS, TOASTER_POSITION.TOP_RIGHT);
            return responseModel;
        } else {
            handleNotify(responseModel.errormessage, TOASTER_TYPE.ERROR, TOASTER_POSITION.TOP_RIGHT);
        }
    }

    // this method to the existing CustomerService 
    static async getCustomerByLeadId(leadId) {
        responseModel = new ResponseModel();
        const requestURL = `${EndPoint.CUSTOMERS}/lead/${leadId}`; // endpoint

        responseModel = await handleGetAsync(requestURL, true);
        if (responseModel) {
            return responseModel;
        } else {
            throw new Error('Failed to fetch customer by Lead ID');
        }
    }


    // convert Lead to Customer
    static async convertLeadToCustomer(values) {
        responseModel = new ResponseModel();
        try {
            responseModel = await handlePostAsync(EndPoint.CUSTOMERS, true, values);
            if (responseModel) {
                handleNotify('Customer created from lead successfully!', TOASTER_TYPE.SUCCESS, TOASTER_POSITION.TOP_RIGHT);
                return responseModel;
            } else {
                throw new Error('Failed to create customer from lead');
            }
        } catch (error) {
            console.error("Error converting lead to customer:", error);
            throw error;
        }
    }

}
